import { AxiosResponse } from "axios";
import { IPartyOptions } from "../features/partiesinvolved/logic/PartiesInvolvedSlice";
import { axiosInstance } from "./common";

export interface PartyOptionsResponse {
  party_options: IPartyOptions[];
}

export const PartyOptionsAPI = {
  get: async (case_id: string): Promise<PartyOptionsResponse> => {
    const response: AxiosResponse<PartyOptionsResponse> =
      await axiosInstance.get(`v1/cases/${case_id}/party-options`);
    return response.data;
  },
};
